angular.module('angular-meteor.settings', [])
  .constant('$angularMeteorSettings', {
    suppressWarnings: true
  });



// WEBPACK FOOTER //
// ./src/modules/angular-meteor-settings.js